"use strict";
/**
 * @packageDocumentation
 * @module ISubscriptionPromise
 */
Object.defineProperty(exports, "__esModule", { value: true });
